import React from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/client';
import { UserInfo } from '@ibinder/common-frontend';
import { ThemeButton, Card } from '@ibinder/ui-common-core';

import { IMPERSONATE } from '../../../../../../api/queries/queries_local';
import { impersonateUser } from '../AdminActionBar/index';
import { useIBTranslation } from '@ibinder/ui-common-hooks';

const UserList = styled.ul`
  padding: 0;
`;

const UserCard = styled.li`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const OrganizationImpersonate = ({ organization, type }) => {
  if (organization.data?.get?.organization?.id) {
    localStorage.setItem('tenantId', organization.data?.get?.organization?.id);
  }

  const { t } = useIBTranslation();

  const [runImpersonate] = useMutation(IMPERSONATE);

  const onImpersonate = async (user) => {
    const response = await runImpersonate({
      variables: {
        input: { targetUserId: user.userId }
      }
    });

    impersonateUser(
      response.data.post.impersonationToken,
      user.name,
      user.userEmail,
      user.userId,
      organization.data?.get,
      organization.data?.get?.organization?.id
    );
  };

  if (!organization.data?.get) {
    return <Card loading={true} />;
  }

  const organizationData = organization.data.get;

  return (
    <>
      <UserList>
        {organizationData.admins.map((user) => {
          return (
            <UserCard key={user.id}>
              <UserInfo
                size={'small'}
                fullName={user.name}
                email={user.userEmail}
              ></UserInfo>
              <ThemeButton
                buttonType="default"
                onClick={() => onImpersonate(user)}
              >
                {t('impersonate')}
              </ThemeButton>
            </UserCard>
          );
        })}
      </UserList>
    </>
  );
};

export default OrganizationImpersonate;
